import { Image, XStack } from 'tamagui';

const images = [
  require('@assets/images/animals/monkey.png'),
  require('@assets/images/animals/fish.png'),
  require('@assets/images/animals/bat.png'),
  require('@assets/images/animals/bird.png'),
  require('@assets/images/animals/dragonfly.png'),
];

export function LoginAnimalImages(): React.ReactNode {
  return (
    <XStack gap="$true" justifyContent="space-between">
      {images.map((image, index) => (
        <Image
          height={50}
          width={50}
          key={index}
          source={image}
          alt={`Animal Icon ${index + 1}`}
        />
      ))}
    </XStack>
  );
}
